import { render, staticRenderFns } from "./SalesItemList.vue?vue&type=template&id=796ca468&scoped=true&"
import script from "./SalesItemList.vue?vue&type=script&lang=js&"
export * from "./SalesItemList.vue?vue&type=script&lang=js&"
import style0 from "./SalesItemList.vue?vue&type=style&index=0&id=796ca468&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796ca468",
  null
  
)

export default component.exports